import React, { Component } from "react";
import { FaCheck } from "react-icons/fa";

import "./SlotGrupo.css";

interface SlotGrupoProps {
  selected: boolean;
  cor: string;
  onClick: () => void;
}

export class SlotGrupo extends Component<SlotGrupoProps> {
  constructor(props: SlotGrupoProps) {
    super(props);
  }

  render(): React.ReactNode {
    return (
      <div className="slot-grupo" onClick={() => this.props.onClick()}>
        <span style={{ backgroundColor: this.props.cor }}>
          {this.props.selected && <FaCheck color="#000" />}
        </span>
      </div>
    );
  }
}
